import { ChangeKeyDataConstant } from "presentation/constant/ChangeKeyData/ChangeKeyDataConstant";
import { cokdTypeDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChangeKeyDataVM } from "presentation/hook/ChangeKeyData/useChangeKeyDataVM";
import { useChangeKeyDataTracked } from "presentation/store/ChangeKeyData/ChangeKeyDataProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, HPHInputTextarea, IFieldValue } from "veronica-ui-component/dist/component/core";

const ChangeKeyDataSearchForm = () => {
    const CONTAINER_CONSTANT = ChangeKeyDataConstant.Charge;
    const [changeKeyDataState] = useChangeKeyDataTracked();
    const changeKeyDataSearchCriteria = changeKeyDataState.searchCriteria;
    const changeKeyDataVM = useChangeKeyDataVM();
    const memoCntrNo = useMemo(() =>
        <div className='flex-row-item'>
            <HPHInputTextarea
                label={CONTAINER_CONSTANT.CNTR_NO}
                width="390px"
                rows={3}
                resizable={false}
                helpIcon={true}
                toolTipText="Use comma ( , ) as delimiter"
                value={changeKeyDataSearchCriteria.cntrNos?.join(",")}
                onChange={(e) => { changeKeyDataVM.onTextAreaChange(e, "cntrNos", true) }} />
        </div>
        , [changeKeyDataSearchCriteria.cntrNos, changeKeyDataVM, CONTAINER_CONSTANT.CNTR_NO])
    const memohandlingStatus = useMemo(() =>
        <div className='flex-row-item' style={{ width: "390px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={changeKeyDataSearchCriteria?.handlingStatus?.join(',')}
                fieldValue={changeKeyDataSearchCriteria?.handlingStatus}
                fieldLabel={CONTAINER_CONSTANT.PROCESS_STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'handlingStatus'}
                maxLength={60}
                isMultipleDropDown={true}
                options={changeKeyDataState.dynamicOptions.handlingStatusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    changeKeyDataVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.PROCESS_STATUS, changeKeyDataSearchCriteria.handlingStatus, changeKeyDataState.dynamicOptions.handlingStatusDropdownOptions, changeKeyDataVM])

    const memoCokdType = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={changeKeyDataSearchCriteria?.cokdTypes?.join(',')}
                fieldValue={changeKeyDataSearchCriteria?.cokdTypes}
                fieldLabel={CONTAINER_CONSTANT.COKD_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cokdTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={cokdTypeDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    changeKeyDataVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.COKD_TYPE, changeKeyDataSearchCriteria.cokdTypes, changeKeyDataVM])
    const memoCokdSubType = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={changeKeyDataSearchCriteria?.cokdSubTypes?.join(',')}
                fieldValue={changeKeyDataSearchCriteria?.cokdSubTypes}
                fieldLabel={CONTAINER_CONSTANT.COKD_SUB_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cokdSubTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={cokdTypeDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    changeKeyDataVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.COKD_SUB_TYPE, changeKeyDataSearchCriteria.cokdSubTypes, changeKeyDataVM])

    const memoVesselCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={changeKeyDataSearchCriteria.vesselCode || ''}
                fieldValue={changeKeyDataSearchCriteria.vesselCode}
                fieldLabel={CONTAINER_CONSTANT.VESSEL_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'vesselCode'}
                maxLength={6}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    changeKeyDataVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.VESSEL_CODE, changeKeyDataSearchCriteria.vesselCode, changeKeyDataVM])
    const memoVoyageCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={changeKeyDataSearchCriteria.voyageCode || ''}
                fieldValue={changeKeyDataSearchCriteria.voyageCode}
                fieldLabel={CONTAINER_CONSTANT.VOYAGE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'voyageCode'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    changeKeyDataVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.VOYAGE_CODE, changeKeyDataSearchCriteria.voyageCode, changeKeyDataVM])
    const memoBillCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={changeKeyDataSearchCriteria.billCode || ''}
                fieldValue={changeKeyDataSearchCriteria.billCode}
                fieldLabel={CONTAINER_CONSTANT.BILL_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billCode'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    changeKeyDataVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.BILL_CODE, changeKeyDataSearchCriteria.billCode, changeKeyDataVM])
    const memoOldBillCode = useMemo(() =>
        <div className='flex-row-item' style={{ width: "180px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={changeKeyDataSearchCriteria.oldBillCode || ''}
                fieldValue={changeKeyDataSearchCriteria.oldBillCode}
                fieldLabel={CONTAINER_CONSTANT.OLD_BILL_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'oldBillCode'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    changeKeyDataVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.OLD_BILL_CODE, changeKeyDataSearchCriteria.oldBillCode, changeKeyDataVM])

    const memoCreatedDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={CONTAINER_CONSTANT.CREATED_DATE_RANGE}
                width='390px'
                fieldNames={{ startField: "createdDateFrom", endField: "createdDateTo" }}
                dateRange={{ startDate: changeKeyDataSearchCriteria.createdDateFrom, endDate: changeKeyDataSearchCriteria.createdDateTo }}
                onDatesChange={changeKeyDataVM.onDateRangeChange}
            />
        </div>
        , [CONTAINER_CONSTANT.CREATED_DATE_RANGE, changeKeyDataSearchCriteria.createdDateFrom, changeKeyDataSearchCriteria.createdDateTo, changeKeyDataVM.onDateRangeChange])



    return <>

        <CriteriaItemContainer>
            {changeKeyDataState.enabledSearchCriteria.handlingStatus ? memohandlingStatus : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {changeKeyDataState.enabledSearchCriteria.cntrNos ? memoCntrNo : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {changeKeyDataState.enabledSearchCriteria.cokdTypes ? memoCokdType : null}
            {changeKeyDataState.enabledSearchCriteria.cokdSubTypes ? memoCokdSubType : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {changeKeyDataState.enabledSearchCriteria.vesselCode ? memoVesselCode : null}
            {changeKeyDataState.enabledSearchCriteria.voyageCode ? memoVoyageCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {changeKeyDataState.enabledSearchCriteria.billCode ? memoBillCode : null}
            {changeKeyDataState.enabledSearchCriteria.oldBillCode ? memoOldBillCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {changeKeyDataState.enabledSearchCriteria.createdDate ? memoCreatedDateFromTo : null}
        </CriteriaItemContainer>

    </>;
}
export default memo(ChangeKeyDataSearchForm);